// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trabalhadores-page {
    display: flex;
    flex-direction: column;
    min-height: 100%;
}

.trabalhadores-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.filter-buttons {
    display: flex;
    gap: 10px;
}

.filter-btn {
    padding: 8px 16px;
    border: 1px solid #ddd;
    background: white;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.85rem;
    transition: all 0.2s;
}

.filter-btn:hover {
    border-color: #667eea;
}

.filter-btn.active {
    background: #667eea;
    color: white;
    border-color: #667eea;
}

/* Trabalhadores Grid */
.trabalhadores-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
}

.trabalhador-card {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    flex-direction: column;
    gap: 15px;
    border: 1px solid transparent;
}

.trabalhador-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
    border-color: #4299e1;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card-body h4 {
    margin: 0 0 5px 0;
    color: #2d3748;
    font-size: 1.1rem;
    font-weight: 600;
}

.card-body p {
    margin: 0;
    font-size: 0.9rem;
    color: #718096;
}

.trabalhador-footer {
    margin-top: auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-top: 1px solid #edf2f7;
    padding-top: 15px;
}

.status-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
}

.status-dot.active {
    background-color: #48bb78;
    box-shadow: 0 0 0 2px #c6f6d5;
}

.status-dot.inactive {
    background-color: #cbd5e0;
}

.trabalhadores-table-container {
    background: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.trabalhadores-table {
    width: 100%;
    border-collapse: collapse;
}

.trabalhadores-table th,
.trabalhadores-table td {
    padding: 12px 16px;
    text-align: left;
    border-bottom: 1px solid #edf2f7;
}

.trabalhadores-table th {
    background: #f8fafc;
    font-weight: 600;
    color: #4a5568;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.trabalhadores-table tr:hover {
    background-color: #f7fafc;
    cursor: pointer;
}

/* Trabalhador inativo: linha marcada, ao jeito das faturas pagas na Gestão
   Financeira — mesma transparência e mesmo esbatimento, cor trocada. */
.trabalhadores-table tr.linha-inativo { background: rgba(239, 68, 68, 0.18) !important; }
.trabalhadores-table tr.linha-inativo:hover { background: rgba(239, 68, 68, 0.28) !important; }
/* Os fundos de hover das células pintam POR CIMA do fundo da linha — vêm de
   .standard-table tr:hover td (App.css) e da regra da linha aqui em cima. Sem
   isto o vermelho desaparecia ao passar o rato. Especificidade (0,3,2) chega
   para ganhar às duas, sem precisar de !important. */
.trabalhadores-table tr.linha-inativo:hover td { background: transparent; }
/* Conteúdo esbatido, fundo não: o opacity vai nas células e não na linha, senão
   esbateria também o vermelho. */
.trabalhadores-table tr.linha-inativo td { opacity: 0.6; }

/* Modal Styles */
.worker-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1100;
    padding: 20px;
    backdrop-filter: blur(2px);
}

.worker-modal {
    background: white;
    border-radius: 12px;
    width: 1150px;
    max-width: 95%;
    height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.worker-modal-header {
    padding: 20px 24px;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.worker-modal-header h2 {
    margin: 0;
    font-size: 20px;
    color: #2d3748;
}

/* Tabs */
.worker-modal-tabs {
    display: flex;
    background: white;
    border-bottom: 1px solid #e2e8f0;
    padding: 0 24px;
}

.worker-tab-btn {
    padding: 16px 20px;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    font-weight: 500;
    color: #718096;
    cursor: pointer;
    transition: all 0.2s;
}

.worker-tab-btn:hover {
    color: #4a5568;
}

.worker-tab-btn.active {
    color: #2b6cb0;
    border-bottom-color: #2b6cb0;
}

.worker-modal-content {
    flex: 1 1;
    overflow-y: auto;
    padding: 24px;
}

/* Custom Scrollbar for modal content */
.worker-modal-content::-webkit-scrollbar {
    width: 8px;
}

.worker-modal-content::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.worker-modal-content::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 4px;
}

.worker-modal-content::-webkit-scrollbar-thumb:hover {
    background: #3182ce;
}

.worker-form-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
}

.worker-form-section {
    margin-bottom: 24px;
}

.worker-form-section h3 {
    grid-column: 1 / -1;
    font-size: 16px;
    color: #2d3748;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 1px solid #edf2f7;
}

.worker-form-field {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.worker-form-field.full-width {
    grid-column: 1 / -1;
}

.worker-form-field label {
    font-size: 13px;
    font-weight: 500;
    color: #4a5568;
}

.worker-form-field input,
.worker-form-field select,
.worker-form-field textarea {
    padding: 8px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 14px;
    transition: border-color 0.2s;
}

.worker-form-field input:focus,
.worker-form-field select:focus,
.worker-form-field textarea:focus {
    border-color: #3182ce;
    outline: none;
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
}

.worker-modal-footer {
    padding: 20px 24px;
    border-top: 1px solid #e2e8f0;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}

.worker-btn-cancel {
    background: white;
    border: 1px solid #cbd5e0;
    padding: 8px 16px;
    border-radius: 6px;
    color: #4a5568;
    cursor: pointer;
}

.worker-btn-save {
    background: #3182ce;
    border: none;
    padding: 8px 24px;
    border-radius: 6px;
    color: white;
    font-weight: 500;
    cursor: pointer;
}

.worker-btn-save:hover {
    background: #2c5282;
}

.signature-upload {
    padding: 15px;
    border: 2px dashed #e2e8f0;
    border-radius: 8px;
    text-align: center;
    background: #f8fafc;
}

.signature-preview {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
}

.help-text {
    font-size: 11px;
    color: #718096;
    margin-top: 5px;
}

.form-section h3 {
    color: #4c51bf !important;
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-icon {
    background: #fed7d7;
    color: #c53030;
    border: none;
    padding: 4px 8px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
}

.btn-dl50 {
    background: #48bb78;
    color: white;
    border: none;
    padding: 10px 16px;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
    width: 100%;
    transition: background 0.2s;
}

.btn-dl50:hover {
    background: #38a169;
}

.actions-cell {
    display: flex;
    gap: 8px;
    align-items: center;
}

.actions-cell button {
    border: none;
    background: none;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
    transition: background 0.2s;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-epi {
    background: #ebf8ff !important;
    color: #3182ce;
}

.btn-epi:hover {
    background: #bee3f8 !important;
}

.actions-cell .btn-epi-today {
    min-width: 76px;
    gap: 5px;
    padding: 5px 8px !important;
    border: 1px solid rgba(66, 153, 225, 0.32) !important;
    background: #edf6ff !important;
    color: #2b6cb0;
    white-space: nowrap;
}

.actions-cell .btn-epi-today:hover:not(:disabled) {
    background: #dbeeff !important;
    border-color: rgba(49, 130, 206, 0.5) !important;
}

.actions-cell .btn-epi-today:disabled {
    cursor: wait;
    opacity: 0.62;
}

.btn-epi-today-label {
    font-size: 0.7rem;
    font-weight: 700;
    line-height: 1;
}

.btn-edit {
    background: #f0fff4 !important;
    color: #38a169;
}

.btn-edit:hover {
    background: #c6f6d5 !important;
}

.btn-delete {
    background: #fff5f5 !important;
    color: #e53e3e;
}

.btn-delete:hover {
    background: #fed7d7 !important;
}

/* Worker Photo Styles */
.worker-photo-section {
    display: flex;
    justify-content: center;
    padding-top: 10px;
    padding-bottom: 24px;
    margin-bottom: 24px;
    border-bottom: 1px solid #edf2f7;
}

.worker-photo-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
}

.worker-avatar-preview {
    width: 130px;
    height: 130px;
    border-radius: 50%;
    object-fit: cover;
    border: 4px solid #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.worker-avatar-placeholder {
    width: 130px;
    height: 130px;
    border-radius: 50%;
    background: #f7fafc;
    border: 2px dashed #cbd5e0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 60px;
    color: #a0aec0;
}

.photo-actions {
    display: flex;
    gap: 12px;
}

.photo-btn {
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 6px;
}

.upload-btn {
    background: #ebf8ff;
    color: #3182ce;
    border: 1px solid #bee3f8;
}

.upload-btn:hover {
    background: #bee3f8;
}

.capture-btn {
    background: #f0fff4;
    color: #38a169;
    border: 1px solid #c6f6d5;
}

.capture-btn:hover {
    background: #c6f6d5;
}

.photo-loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 130px;
    height: 130px;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #2b6cb0;
    font-weight: 600;
}

/* Nome do trabalhador a seguir ao título do modal. Mais leve que o título
   para se ler como contexto e não competir com ele. */
.worker-modal-nome {
    margin-left: 10px;
    padding-left: 12px;
    border-left: 2px solid #cbd5e0;
    font-size: 0.85em;
    font-weight: 500;
    color: #2b6cb0;
}

/* ============================================================
   CARTÕES ASSOCIADOS — que cartões de débito esta pessoa usa

   Uma pessoa usa vários (o físico e o online), por isso é uma lista de
   escolhas e não um campo único. O nome do cartão traz o banco e o titular
   pelo meio ("|| BCP || F (Tiago Paula) > Nuno Machado"), daí a linha ser
   larga e o número ficar por baixo em vez de ao lado.
   ============================================================ */
.cartoes-assoc-lista {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.cartao-assoc {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: #fff;
    cursor: pointer;
    transition: background .15s, border-color .15s;
}
.cartao-assoc:hover { background: #f7fafc; }
.cartao-assoc.escolhido { border-color: #38a169; background: #f0fff4; }
.cartao-assoc input[type="checkbox"] {
    width: 17px; height: 17px; flex-shrink: 0; cursor: pointer; margin: 0;
}
.cartao-assoc-nome {
    flex: 1 1;
    font-weight: 600;
    color: #2d3748;
    font-size: 14px;
    min-width: 0;
}
/* Coluna «M» (Manutenção): cabeçalho e caixa de cada cartão */
.cartoes-assoc-cab {
    display: flex;
    align-items: center;
    padding: 0 14px;
    font-size: 11.5px;
    font-weight: 700;
    color: #718096;
    letter-spacing: .04em;
    text-transform: uppercase;
}
.cartoes-assoc-cab > span:first-child { flex: 1 1; padding-left: 29px; }
.cartao-assoc-principal {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1 1;
    min-width: 0;
    margin: 0;
    cursor: pointer;
}
.cartao-assoc-m {
    flex-shrink: 0;
    width: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid #e2e8f0;
    align-self: stretch;
}
.cartoes-assoc-cab .cartao-assoc-m { border-left: none; }
.cartao-assoc-nome small {
    display: block;
    font-weight: 400;
    color: #718096;
    font-size: 12px;
    margin-top: 2px;
}
/* Cartão que já está entregue a outra pessoa: escolhê-lo tira-lho, e isso
   tem de se ver antes de carregar, não depois de gravar. */
.cartao-assoc-dono {
    flex-shrink: 0;
    font-size: 11.5px;
    font-weight: 600;
    color: #9a3412;
    background: #ffedd5;
    border-radius: 999px;
    padding: 3px 10px;
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Trabalhadores.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;uEACuE;AACvE,wCAAwC,8CAA8C,EAAE;AACxF,8CAA8C,8CAA8C,EAAE;AAC9F;;;qDAGqD;AACrD,iDAAiD,uBAAuB,EAAE;AAC1E;iCACiC;AACjC,2CAA2C,YAAY,EAAE;;AAEzD,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,qFAAqF;AACzF;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA,SAAS;AACT;IACI,aAAa;IACb,iBAAiB;IACjB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;AACjB;;AAEA,uCAAuC;AACvC;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;;IAGI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;AACjC;;AAEA;;;IAGI,qBAAqB;IACrB,aAAa;IACb,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,2BAA2B;IAC3B,qDAAqD;IACrD,8BAA8B;IAC9B,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,gDAAgD;AACpD;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;sDACsD;AACtD;IACI,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;;;;;;iEAOiE;AACjE;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,8CAA8C;AAClD;AACA,sBAAsB,mBAAmB,EAAE;AAC3C,0BAA0B,qBAAqB,EAAE,mBAAmB,EAAE;AACtE;IACI,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE,eAAe,EAAE,SAAS;AACzE;AACA;IACI,SAAO;IACP,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,YAAY;AAChB;AACA,8DAA8D;AAC9D;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,yBAAyB;AAC7B;AACA,wCAAwC,SAAO,EAAE,kBAAkB,EAAE;AACrE;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;IACP,YAAY;IACZ,SAAS;IACT,eAAe;AACnB;AACA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,mBAAmB;AACvB;AACA,qCAAqC,iBAAiB,EAAE;AACxD;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,eAAe;AACnB;AACA;2DAC2D;AAC3D;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;AACvB","sourcesContent":[".trabalhadores-page {\n    display: flex;\n    flex-direction: column;\n    min-height: 100%;\n}\n\n.trabalhadores-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n}\n\n.filter-buttons {\n    display: flex;\n    gap: 10px;\n}\n\n.filter-btn {\n    padding: 8px 16px;\n    border: 1px solid #ddd;\n    background: white;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 0.85rem;\n    transition: all 0.2s;\n}\n\n.filter-btn:hover {\n    border-color: #667eea;\n}\n\n.filter-btn.active {\n    background: #667eea;\n    color: white;\n    border-color: #667eea;\n}\n\n/* Trabalhadores Grid */\n.trabalhadores-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 20px;\n}\n\n.trabalhador-card {\n    background: white;\n    border-radius: 12px;\n    padding: 20px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n    cursor: pointer;\n    transition: all 0.2s;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    border: 1px solid transparent;\n}\n\n.trabalhador-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);\n    border-color: #4299e1;\n}\n\n.card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.card-body h4 {\n    margin: 0 0 5px 0;\n    color: #2d3748;\n    font-size: 1.1rem;\n    font-weight: 600;\n}\n\n.card-body p {\n    margin: 0;\n    font-size: 0.9rem;\n    color: #718096;\n}\n\n.trabalhador-footer {\n    margin-top: auto;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    border-top: 1px solid #edf2f7;\n    padding-top: 15px;\n}\n\n.status-dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    display: inline-block;\n}\n\n.status-dot.active {\n    background-color: #48bb78;\n    box-shadow: 0 0 0 2px #c6f6d5;\n}\n\n.status-dot.inactive {\n    background-color: #cbd5e0;\n}\n\n.trabalhadores-table-container {\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n}\n\n.trabalhadores-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.trabalhadores-table th,\n.trabalhadores-table td {\n    padding: 12px 16px;\n    text-align: left;\n    border-bottom: 1px solid #edf2f7;\n}\n\n.trabalhadores-table th {\n    background: #f8fafc;\n    font-weight: 600;\n    color: #4a5568;\n    font-size: 13px;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.trabalhadores-table tr:hover {\n    background-color: #f7fafc;\n    cursor: pointer;\n}\n\n/* Trabalhador inativo: linha marcada, ao jeito das faturas pagas na Gestão\n   Financeira — mesma transparência e mesmo esbatimento, cor trocada. */\n.trabalhadores-table tr.linha-inativo { background: rgba(239, 68, 68, 0.18) !important; }\n.trabalhadores-table tr.linha-inativo:hover { background: rgba(239, 68, 68, 0.28) !important; }\n/* Os fundos de hover das células pintam POR CIMA do fundo da linha — vêm de\n   .standard-table tr:hover td (App.css) e da regra da linha aqui em cima. Sem\n   isto o vermelho desaparecia ao passar o rato. Especificidade (0,3,2) chega\n   para ganhar às duas, sem precisar de !important. */\n.trabalhadores-table tr.linha-inativo:hover td { background: transparent; }\n/* Conteúdo esbatido, fundo não: o opacity vai nas células e não na linha, senão\n   esbateria também o vermelho. */\n.trabalhadores-table tr.linha-inativo td { opacity: 0.6; }\n\n/* Modal Styles */\n.worker-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1100;\n    padding: 20px;\n    backdrop-filter: blur(2px);\n}\n\n.worker-modal {\n    background: white;\n    border-radius: 12px;\n    width: 1150px;\n    max-width: 95%;\n    height: 85vh;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n.worker-modal-header {\n    padding: 20px 24px;\n    border-bottom: 1px solid #e2e8f0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.worker-modal-header h2 {\n    margin: 0;\n    font-size: 20px;\n    color: #2d3748;\n}\n\n/* Tabs */\n.worker-modal-tabs {\n    display: flex;\n    background: white;\n    border-bottom: 1px solid #e2e8f0;\n    padding: 0 24px;\n}\n\n.worker-tab-btn {\n    padding: 16px 20px;\n    background: none;\n    border: none;\n    border-bottom: 2px solid transparent;\n    font-weight: 500;\n    color: #718096;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.worker-tab-btn:hover {\n    color: #4a5568;\n}\n\n.worker-tab-btn.active {\n    color: #2b6cb0;\n    border-bottom-color: #2b6cb0;\n}\n\n.worker-modal-content {\n    flex: 1;\n    overflow-y: auto;\n    padding: 24px;\n}\n\n/* Custom Scrollbar for modal content */\n.worker-modal-content::-webkit-scrollbar {\n    width: 8px;\n}\n\n.worker-modal-content::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n}\n\n.worker-modal-content::-webkit-scrollbar-thumb {\n    background: #cbd5e0;\n    border-radius: 4px;\n}\n\n.worker-modal-content::-webkit-scrollbar-thumb:hover {\n    background: #3182ce;\n}\n\n.worker-form-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 20px;\n}\n\n.worker-form-section {\n    margin-bottom: 24px;\n}\n\n.worker-form-section h3 {\n    grid-column: 1 / -1;\n    font-size: 16px;\n    color: #2d3748;\n    margin-bottom: 16px;\n    padding-bottom: 8px;\n    border-bottom: 1px solid #edf2f7;\n}\n\n.worker-form-field {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.worker-form-field.full-width {\n    grid-column: 1 / -1;\n}\n\n.worker-form-field label {\n    font-size: 13px;\n    font-weight: 500;\n    color: #4a5568;\n}\n\n.worker-form-field input,\n.worker-form-field select,\n.worker-form-field textarea {\n    padding: 8px 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    font-size: 14px;\n    transition: border-color 0.2s;\n}\n\n.worker-form-field input:focus,\n.worker-form-field select:focus,\n.worker-form-field textarea:focus {\n    border-color: #3182ce;\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);\n}\n\n.worker-modal-footer {\n    padding: 20px 24px;\n    border-top: 1px solid #e2e8f0;\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n}\n\n.worker-btn-cancel {\n    background: white;\n    border: 1px solid #cbd5e0;\n    padding: 8px 16px;\n    border-radius: 6px;\n    color: #4a5568;\n    cursor: pointer;\n}\n\n.worker-btn-save {\n    background: #3182ce;\n    border: none;\n    padding: 8px 24px;\n    border-radius: 6px;\n    color: white;\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.worker-btn-save:hover {\n    background: #2c5282;\n}\n\n.signature-upload {\n    padding: 15px;\n    border: 2px dashed #e2e8f0;\n    border-radius: 8px;\n    text-align: center;\n    background: #f8fafc;\n}\n\n.signature-preview {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: relative;\n}\n\n.help-text {\n    font-size: 11px;\n    color: #718096;\n    margin-top: 5px;\n}\n\n.form-section h3 {\n    color: #4c51bf !important;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.btn-icon {\n    background: #fed7d7;\n    color: #c53030;\n    border: none;\n    padding: 4px 8px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n}\n\n.btn-dl50 {\n    background: #48bb78;\n    color: white;\n    border: none;\n    padding: 10px 16px;\n    border-radius: 6px;\n    font-weight: 600;\n    cursor: pointer;\n    width: 100%;\n    transition: background 0.2s;\n}\n\n.btn-dl50:hover {\n    background: #38a169;\n}\n\n.actions-cell {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.actions-cell button {\n    border: none;\n    background: none;\n    padding: 6px;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background 0.2s;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.btn-epi {\n    background: #ebf8ff !important;\n    color: #3182ce;\n}\n\n.btn-epi:hover {\n    background: #bee3f8 !important;\n}\n\n.actions-cell .btn-epi-today {\n    min-width: 76px;\n    gap: 5px;\n    padding: 5px 8px !important;\n    border: 1px solid rgba(66, 153, 225, 0.32) !important;\n    background: #edf6ff !important;\n    color: #2b6cb0;\n    white-space: nowrap;\n}\n\n.actions-cell .btn-epi-today:hover:not(:disabled) {\n    background: #dbeeff !important;\n    border-color: rgba(49, 130, 206, 0.5) !important;\n}\n\n.actions-cell .btn-epi-today:disabled {\n    cursor: wait;\n    opacity: 0.62;\n}\n\n.btn-epi-today-label {\n    font-size: 0.7rem;\n    font-weight: 700;\n    line-height: 1;\n}\n\n.btn-edit {\n    background: #f0fff4 !important;\n    color: #38a169;\n}\n\n.btn-edit:hover {\n    background: #c6f6d5 !important;\n}\n\n.btn-delete {\n    background: #fff5f5 !important;\n    color: #e53e3e;\n}\n\n.btn-delete:hover {\n    background: #fed7d7 !important;\n}\n\n/* Worker Photo Styles */\n.worker-photo-section {\n    display: flex;\n    justify-content: center;\n    padding-top: 10px;\n    padding-bottom: 24px;\n    margin-bottom: 24px;\n    border-bottom: 1px solid #edf2f7;\n}\n\n.worker-photo-container {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 15px;\n}\n\n.worker-avatar-preview {\n    width: 130px;\n    height: 130px;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 4px solid #fff;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.worker-avatar-placeholder {\n    width: 130px;\n    height: 130px;\n    border-radius: 50%;\n    background: #f7fafc;\n    border: 2px dashed #cbd5e0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 60px;\n    color: #a0aec0;\n}\n\n.photo-actions {\n    display: flex;\n    gap: 12px;\n}\n\n.photo-btn {\n    padding: 8px 16px;\n    border-radius: 20px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.upload-btn {\n    background: #ebf8ff;\n    color: #3182ce;\n    border: 1px solid #bee3f8;\n}\n\n.upload-btn:hover {\n    background: #bee3f8;\n}\n\n.capture-btn {\n    background: #f0fff4;\n    color: #38a169;\n    border: 1px solid #c6f6d5;\n}\n\n.capture-btn:hover {\n    background: #c6f6d5;\n}\n\n.photo-loader {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 130px;\n    height: 130px;\n    background: rgba(255, 255, 255, 0.7);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    color: #2b6cb0;\n    font-weight: 600;\n}\n\n/* Nome do trabalhador a seguir ao título do modal. Mais leve que o título\n   para se ler como contexto e não competir com ele. */\n.worker-modal-nome {\n    margin-left: 10px;\n    padding-left: 12px;\n    border-left: 2px solid #cbd5e0;\n    font-size: 0.85em;\n    font-weight: 500;\n    color: #2b6cb0;\n}\n\n/* ============================================================\n   CARTÕES ASSOCIADOS — que cartões de débito esta pessoa usa\n\n   Uma pessoa usa vários (o físico e o online), por isso é uma lista de\n   escolhas e não um campo único. O nome do cartão traz o banco e o titular\n   pelo meio (\"|| BCP || F (Tiago Paula) > Nuno Machado\"), daí a linha ser\n   larga e o número ficar por baixo em vez de ao lado.\n   ============================================================ */\n.cartoes-assoc-lista {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n.cartao-assoc {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 14px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    background: #fff;\n    cursor: pointer;\n    transition: background .15s, border-color .15s;\n}\n.cartao-assoc:hover { background: #f7fafc; }\n.cartao-assoc.escolhido { border-color: #38a169; background: #f0fff4; }\n.cartao-assoc input[type=\"checkbox\"] {\n    width: 17px; height: 17px; flex-shrink: 0; cursor: pointer; margin: 0;\n}\n.cartao-assoc-nome {\n    flex: 1;\n    font-weight: 600;\n    color: #2d3748;\n    font-size: 14px;\n    min-width: 0;\n}\n/* Coluna «M» (Manutenção): cabeçalho e caixa de cada cartão */\n.cartoes-assoc-cab {\n    display: flex;\n    align-items: center;\n    padding: 0 14px;\n    font-size: 11.5px;\n    font-weight: 700;\n    color: #718096;\n    letter-spacing: .04em;\n    text-transform: uppercase;\n}\n.cartoes-assoc-cab > span:first-child { flex: 1; padding-left: 29px; }\n.cartao-assoc-principal {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex: 1;\n    min-width: 0;\n    margin: 0;\n    cursor: pointer;\n}\n.cartao-assoc-m {\n    flex-shrink: 0;\n    width: 34px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-left: 1px solid #e2e8f0;\n    align-self: stretch;\n}\n.cartoes-assoc-cab .cartao-assoc-m { border-left: none; }\n.cartao-assoc-nome small {\n    display: block;\n    font-weight: 400;\n    color: #718096;\n    font-size: 12px;\n    margin-top: 2px;\n}\n/* Cartão que já está entregue a outra pessoa: escolhê-lo tira-lho, e isso\n   tem de se ver antes de carregar, não depois de gravar. */\n.cartao-assoc-dono {\n    flex-shrink: 0;\n    font-size: 11.5px;\n    font-weight: 600;\n    color: #9a3412;\n    background: #ffedd5;\n    border-radius: 999px;\n    padding: 3px 10px;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
